// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

// https://spin.atomicobject.com/2018/02/23/error-either-typescript/
type Result<T> = T | Error;
export type Type<T> = Result<T>;

export function isError<T>(result: Result<T>): result is Error {
    return result instanceof Error;
}

export function isSuccess<T>(result: Result<T>): result is T {
    return !isError(result);
}
